import { Component, OnInit } from '@angular/core';
import { NavbarService } from '../primary-nav/primary-nav.service';

@Component({
    selector: 're-primary-help',
    templateUrl: './primary-help.component.html',
    styleUrls: ['./primary-help.component.scss'],
    standalone: false
})
export class PrimaryHelpComponent implements OnInit {

  constructor(public nav: NavbarService) { }

  ngOnInit() {
    this.nav.hide();
  }

}
